import { StoreFactories } from "@com.mgmtp.a12.client/client-core/lib/core/store";
import { UaaActions } from "@com.mgmtp.a12.uaa/uaa-authentication-client";

import { channel } from "../../utilities/channel";

let unsubscribe: (() => void) | undefined;

export const logoutInAllTabsMiddleware = StoreFactories.createMiddleware((api, next, action) => {
	if (UaaActions.loggingOut.match(action)) {
		unsubscribe?.();
		channel.post({ type: "logout" });
	} else if (UaaActions.loggedIn.match(action)) {
		unsubscribe?.();

		unsubscribe = channel.subscribe(function (message) {
			if (message.type === "logout") {
				unsubscribe?.();
				window.onbeforeunload = () => {};
				api.dispatch(UaaActions.loggingOut());
			}
		});
	}

	return next(action);
});
